module.exports = __webpack_public_path__ + "img/defaultImg.c948b7eb.jpg";